/**
 * Central CTA + facts table for the public site (spec 010 §5.2).
 * Marketing pages import from here and never inline these labels or hrefs.
 */

/**
 * Open diagnostic facts. All marketing copy reads from this constant.
 * VERIFIED 2026-09-30 against the seeded 'Initial Diagnostic' template (V073:
 * question_count 24, time_limit_min 60), which backs GET /api/v1/sat/open/diagnostic-form.
 * (The backend was not running at verification time, so the migration was the source.)
 */
export const DIAGNOSTIC_FACTS = { questions: 24, minutesLabel: 'under an hour' } as const;

export interface MarketingCta {
  label: string;
  href: string;
}

export const COURSE_HREF = '/what-we-do/sat/';
export const COURSE_ABOUT_HREF = '/what-we-do/sat/about/';
export const COURSE_HOW_HREF = '/how-it-works/sat/';
export const DIAGNOSTIC_HREF = '/what-we-do/sat/diagnostic';

export const MARKETING_CTAS = {
  /** Topbar top-level link (with dot badge). */
  courseNav: { label: 'Free SAT course', href: COURSE_HREF },
  /** Topbar primary (desktop). */
  topbarPrimary: { label: 'Start free SAT course', href: COURSE_HREF },
  /** Topbar primary (mobile, compact). */
  topbarPrimaryCompact: { label: 'Start free', href: COURSE_HREF },
  /** Close-of-page CTA on /about/, /faq/. */
  closeCourse: { label: 'Start the free SAT course →', href: COURSE_HREF },
  /**
   * Every "Start the free diagnostic" on `/`: straight to the diagnostic, which opens on the
   * Bluebook cover (title, 24 questions, time limit, a Start button). The timer begins only on
   * Start (`openDiagnosticTransport.start`), so nothing is lost by landing there directly.
   */
  home: { label: 'Start the free diagnostic →', href: DIAGNOSTIC_HREF },
  /** Hero text link on `/`: the difficulty ladder just below the fold. */
  homeSkip: { label: 'See how hard it gets ↓', href: '#try' },
  diagnostic: { label: 'Start the diagnostic →', href: DIAGNOSTIC_HREF },
  courseAboutPrimary: { label: 'Start the free course →', href: COURSE_HREF },
  courseAboutSecondary: { label: 'How tutoring works', href: '/how-it-works/students/' },
  students: { label: 'Find a tutor', href: '/register' },
  parents: { label: 'Create a parent account', href: '/register?role=parent' },
  tutors: { label: 'Apply to tutor', href: '/register' },
  courseHookStart: { label: 'Start →', href: COURSE_HREF },
  howItWorksSatPrimary: { label: 'Start the free course →', href: COURSE_HREF },
  howItWorksSatSecondary: { label: 'Inside the course →', href: COURSE_ABOUT_HREF },
  login: { label: 'Log in', href: '/login' },
  /** intent=sat: the register page then says progress is saved and lands the student in the course. */
  createAccount: { label: 'Create free account', href: '/register?intent=sat' },
} as const satisfies Record<string, MarketingCta>;

export type MarketingCtaKey = keyof typeof MARKETING_CTAS;
